const money = value => Math.round((value + Number.EPSILON) * 100) / 100;
export const materialQuantity = row => Number(row.luat) > 0 ? Number(row.luat) : Number(row.deluat) > 0 ? Number(row.deluat) : Number(row.bxnorma) || 0;

export function calculateDevizTotals(order, firma, parts) {
  if (![0, 1].includes(Number(firma?.platitor_tva)) || firma?.platitor_tva == null) {
    throw new Error("Statutul TVA al firmei nu este configurat.");
  }
  const groups = new Map();
  const rateFor = id => {
    if (!Number(firma.platitor_tva)) return 0;
    const part = parts.get(Number(id));
    const rate = part?.grupa_produse?.bxvat_procent ?? part?.bxvat_procent;
    if (rate == null || rate === "" || !Number.isFinite(Number(rate)) || Number(rate) < 0) {
      throw new Error(`Configurează cota TVA în grupa articolului ${part?.cod || id}.`);
    }
    return Number(rate);
  };
  const add = (base, partId) => {
    const amount = money(base);
    const rate = rateFor(partId);
    const group = groups.get(rate) || { rate, base: 0, vat: 0 };
    group.base = money(group.base + amount);
    group.vat = money(group.vat + money(amount * rate / 100));
    groups.set(rate, group);
    return amount;
  };
  const labor = money((order.manopere || []).reduce((sum, row) => sum + add((Number(row.bxqty_manopera) || 0) * (Number(row.bxpret_manopera) || 0), order.bxpart_id), 0));
  const materials = money((order.reteta || []).reduce((sum, row) => sum + add(materialQuantity(row) * (Number(row.pretvanzare) || 0), row.bxpart_id), 0));
  const vatRows = [...groups.values()].sort((a, b) => a.rate - b.rate);
  const vat = money(vatRows.reduce((sum, group) => sum + group.vat, 0));
  return { labor, materials, subtotal: money(labor + materials), vatRows, vat, total: money(labor + materials + vat) };
}
